import { TCommentRichContent } from './rich-content';
import { IUserAuthInfo } from 'shared/models/user-auth-info';
import { IImage } from '../media';
import { CommentJsonLDUtil } from 'shared/models/comments/json-ld-util';

export interface IBaseComment {
  commentId: string;
  // timestamp in second
  createTime: number;

  author: {
    userId: string;
    avatar: string;
    linkName: string;
    nickName: string;
    authInfo: IUserAuthInfo;
  };

  // content
  text: string;
  richContent?: TCommentRichContent[];
  imageList?: IImage[];

  // interaction
  diggCount: number;
}

/**
 * 1st-level comment
 */
export interface IPrimaryComment extends IBaseComment {
  replyCount: number;
}

/**
 * 2nd-level comment
 */
export interface IReply extends IBaseComment {
  replyToCommentId: string;
}

/**
 * 3rd-level comment
 */
export interface IReplyToReply extends IReply {
  replyToReplyId: string;
}

export type TComment = IPrimaryComment | IReply | IReplyToReply;

export const CommentUtil = {
  isReply(comment: TComment): comment is IReply {
    return (comment as IReply).replyToCommentId !== void 0;
  },
  isPrimaryComment(comment: TComment): comment is IPrimaryComment {
    return !CommentUtil.isReply(comment);
  },
  isReplyToReply: (comment: TComment): comment is IReplyToReply => {
    return CommentUtil.isReply(comment) && (comment as IReplyToReply).replyToReplyId !== void 0;
  },
  JsonLd: CommentJsonLDUtil,
};

export const CommentRichContentUtil = {};
